import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch,
  SwitchProps,
  Text,
  useDisclosure,
} from '@elkaso-app/web-design';
import { useToggleRestaurantUserActivationApi } from 'apis/restaurants/restaurant-users/use-toggle-restaurant-user-activation-api';
import { useParams } from 'react-router-dom';

export interface IRestaurantUserActivationSwitchCell extends SwitchProps {
  userId: number;
  isActive: boolean;
}

export const RestaurantUserActivationSwitch = ({ userId, isActive, ...rest }: IRestaurantUserActivationSwitchCell) => {
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate: toggleActivation, isLoading: isToggleActivationLoading } = useToggleRestaurantUserActivationApi(
    restaurantId!,
    userId
  );

  const handleActivateUser = () => {
    const variables = {
      body: {
        isActive: !isActive,
      },
    };

    toggleActivation(variables, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <>
      <FormControl display='flex' alignItems='center'>
        <Switch id={`active-restaurant-user-${userId}`} onChange={onOpen} isChecked={isActive} {...rest} />
        <FormLabel
          htmlFor={`active-restaurant-user-${userId}`}
          mb='0'
          ms='sm'
          userSelect='none'
          fontWeight='normal'
          fontSize='sm'>
          {isActive ? 'Active' : 'Inactive'}
        </FormLabel>
      </FormControl>

      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{isActive ? 'Deactivate' : 'Activate'} restaurant user!</ModalHeader>

          <ModalBody>
            {isActive && (
              <>
                <Text>Are you sure you want to deactivate this restaurant user?</Text>
                <Text>This user won&apos;t be able to login until the user is activated again.</Text>
              </>
            )}

            {!isActive && (
              <>
                <Text>Are you sure you want to activate this restaurant user?</Text>
                <Text>This user will be able to login after activation.</Text>
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <HStack spacing='md'>
              <Button variant='outline' colorScheme='red' onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant='solid'
                colorScheme='red'
                onClick={handleActivateUser}
                isLoading={isToggleActivationLoading}>
                {isActive ? 'Deactivate' : 'Activate'}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
